import axios from "axios"
import { useState } from "react"
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  CardText,
  CardTitle,
  Col,
  Input,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap"
import { api, token } from "../../../utils/variables"
import { FaLock } from "react-icons/fa"

import scenerio1 from "../../../../src/assets/images/charts/Scenerio_1.png"
import scenerio2 from "../../../../src/assets/images/charts/Scenerio_2.png"
import scenerio3 from "../../../../src/assets/images/charts/Scenerio_3.png"
import scenerio4 from "../../../../src/assets/images/charts/Scenerio_4.png"
import scenerio5 from "../../../../src/assets/images/charts/Scenerio_5.png"

export default function GraphTrends({ modaltoggle, togglemodal }) {
  const [inputValue, setInputValue] = useState("")
  const [visible, setVisible] = useState(false)

  return (
    <Modal
      isOpen={modaltoggle}
      toggle={() => {
        togglemodal()
      }}
      centered
      size="lg"
      style={{ maxHeight: "90vh" }}
    >
      <div className="modal-header">
        <div className="d-flex justify-content-start gap-2 align-items-center">
          <i className="bx bx-chart bx-sm"></i>
          <h5 className="modal-title" id="staticBackdropLabel">
            Graph Trends
          </h5>
        </div>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            togglemodal()
          }}
          aria-label="Close"
        ></button>
      </div>
      <ModalBody
        style={{
          maxHeight: "80vh",
          // minHeight: "40vh",
          padding: "20px",
          overflowY: "auto",
        }}
      >
        <div>
          {/* return search list */}
          <Row classname="d-flex align-items-stretch" id="section_1">
            <Col className="mt-2">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    <strong>Scenario 1: </strong> Rank{" "}
                    <strong>
                      <span className="text-success">↓</span>
                    </strong>
                    , Downloads{" "}
                    <strong>
                      <span className="text-success">↑</span>
                    </strong>
                    , Revenue{" "}
                    <strong>
                      <span className="text-success">↑</span>
                    </strong>
                  </CardTitle>
                  <div style={{ marginBottom: "16px" }}>
                    <strong>📘 Meaning:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Your app is gaining visibility (better rank), attracting
                      more users (higher downloads), and converting well (higher
                      revenue).
                    </p>
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <strong>💡 Interpretation:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Successful campaign or ASO; app is well-optimized for
                      monetization.
                    </p>
                  </div>

                  <div>
                    <img
                      src={scenerio1}
                      alt="Rank, Downloads, Revenue Chart"
                      style={{
                        marginTop: "8px",
                        width: "100%",
                        borderRadius: "12px",
                        border: "1px solid #444",
                      }}
                    />
                  </div>
                </CardBody>
                {/* <CardFooter className="w-100">
                  <Button
                    className="w-100"
                    color="primary"
                    onClick={() => setVisible(true)}
                  >
                    BUY @ 29.99$
                  </Button>
                </CardFooter> */}
              </Card>
            </Col>
          </Row>
          <Row classname="d-flex align-items-stretch" id="section_2">
            <Col className="mt-2">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    <strong>Scenario 2: </strong> Rank{" "}
                    <strong>
                      <span className="text-danger">↑</span>
                    </strong>
                    , Downloads{" "}
                    <strong>
                      <span className="text-danger">↓</span>
                    </strong>
                    , Revenue{" "}
                    <strong>
                      <span className="text-danger">↓</span>
                    </strong>
                  </CardTitle>
                  <div style={{ marginBottom: "16px" }}>
                    <strong>📘 Meaning:</strong>
                    <p style={{ marginTop: "4px" }}>
                      App visibility is dropping, fewer users are downloading
                      it, and revenue is declining.
                    </p>
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <strong>💡 Interpretation:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Likely due to negative user reviews, lack of updates, or
                      stronger competition.
                    </p>
                  </div>

                  <div>
                    <img
                      src={scenerio2}
                      alt="Rank, Downloads, Revenue Chart"
                      style={{
                        marginTop: "8px",
                        width: "100%",
                        borderRadius: "12px",
                        border: "1px solid #444",
                      }}
                    />
                  </div>
                </CardBody>
                {/* <CardFooter className="w-100">
                  <Button
                    className="w-100"
                    color="primary"
                    onClick={() => setVisible(true)}
                  >
                    BUY @ 29.99$
                  </Button>
                </CardFooter> */}
              </Card>
            </Col>
          </Row>
          <Row classname="d-flex align-items-stretch" id="section_3">
            <Col className="mt-2">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    <strong>Scenario 3: </strong> Rank{" "}
                    <strong>
                      <span className="text-success">↓</span>
                    </strong>
                    , Downloads{" "}
                    <strong>
                      <span className="text-success">↑</span>
                    </strong>
                    , Revenue{" "}
                    <strong>
                      <span className="text-danger">↓</span>
                    </strong>
                  </CardTitle>
                  <div style={{ marginBottom: "16px" }}>
                    <strong>📘 Meaning:</strong>
                    <p style={{ marginTop: "4px" }}>
                      App is visible and being downloaded more, but not
                      monetizing effectively.
                    </p>
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <strong>💡 Interpretation:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Time to review monetization strategy—e.g., IAP, ads, or
                      pricing.
                    </p>
                  </div>

                  <div>
                    <img
                      src={scenerio3}
                      alt="Rank, Downloads, Revenue Chart"
                      style={{
                        marginTop: "8px",
                        width: "100%",
                        borderRadius: "12px",
                        border: "1px solid #444",
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row classname="d-flex align-items-stretch" id="section_4">
            <Col className="mt-2">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    <strong>Scenario 4: </strong> Rank{" "}
                    <strong>
                      <span className="text-danger">↑</span>
                    </strong>
                    , Downloads{" "}
                    <strong>
                      <span className="text-danger">↓</span>
                    </strong>
                    , Revenue{" "}
                    <strong>
                      <span className="text-success">↑</span>
                    </strong>
                  </CardTitle>
                  <div style={{ marginBottom: "16px" }}>
                    <strong>📘 Meaning:</strong>
                    <p style={{ marginTop: "4px" }}>
                      App is losing visibility and downloads, but revenue is
                      going up.
                    </p>
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <strong>💡 Interpretation:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Smaller user base is converting better; possible premium
                      feature engagement.
                    </p>
                  </div>

                  <div>
                    <img
                      src={scenerio4}
                      alt="Rank, Downloads, Revenue Chart"
                      style={{
                        marginTop: "8px",
                        width: "100%",
                        borderRadius: "12px",
                        border: "1px solid #444",
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row classname="d-flex align-items-stretch" id="section_5">
            <Col className="mt-2">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    <strong>Scenario 5: </strong> Rank{" "}
                    <strong>
                      <span className="text-warning">⇄</span>
                    </strong>
                    , Downloads{" "}
                    <strong>
                      <span className="text-success">↑</span>
                    </strong>
                    , Revenue{" "}
                    <strong>
                      <span className="text-warning">⇄</span>
                    </strong>
                  </CardTitle>
                  <div style={{ marginBottom: "16px" }}>
                    <strong>📘 Meaning:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Visibility stable, more downloads, but revenue flat.
                    </p>
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <strong>💡 Interpretation:</strong>
                    <p style={{ marginTop: "4px" }}>
                      Great traction but monetization needs improvement.
                    </p>
                  </div>

                  <div>
                    <img
                      src={scenerio5}
                      alt="Rank, Downloads, Revenue Chart"
                      style={{
                        marginTop: "8px",
                        width: "100%",
                        borderRadius: "12px",
                        border: "1px solid #444",
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  )
}
